<template>
  <div class="content mb-3">
    <b-form>
      <b-col>
        <h3 class="title" v-translate>TRANSFERS</h3>
        <b-row>
          <b-col sm="9">
            <b-row>
              <b-col md="4">
                 <b-form-group
                    :label="$gettext('Transfer from')"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="transfer_from"
                  >
                  <b-form-select
                    class="mv-form-control form-control"
                    id="transfer_from"
                    size="sm"
                    v-model="transferFrom"
                    :options="transferLocation"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                  </template>
                  </b-form-select>
                 </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    :label="$gettext('To')"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="to"
                  >
                  <b-form-select
                    class="mv-form-control form-control"
                    id="to"
                    size="sm"
                    v-model="to"
                    :options="transferLocation"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                  </template>
                  </b-form-select>
                 </b-form-group>
              </b-col>
              <b-col md="4" class="pt-1">
                <label class="font-weight-bold form-label"></label>
                <b-button block size="sm" class="mv-custom-blue" v-translate>Services fee</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                 <b-form-group
                    :label="$gettext('Transfer type')"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="car_type"
                  >
                  <b-form-select
                    class="mv-form-control form-control"
                    id="car_type"
                    size="sm"
                    v-model="transferType"
                    :options="transferTypes"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                  </template>
                  </b-form-select>
                 </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$gettext('Pick up date')"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="pick_up"
                  class="date-time"
                  >
                    <DatePicker
                      id="pick_up"
                      size="sm"
                      lang="en"
                      :today-label="$gettext('today')"
                      :selected-date-label="$gettext('selected date')"
                      placeholder="zz/ll/aaaa"
                    >
                    </DatePicker>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  :label="$gettext('Days')"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="days">
                  <b-input
                    class="mv-input form-control"
                    size="sm"
                   />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  :label="$gettext('Drop of date')"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="drop_of"
                  class="date-time"
                  >
                    <DatePicker
                      id="drop_of"
                      size="sm"
                      lang="en"
                      :today-label="$gettext('today')"
                      :selected-date-label="$gettext('selected date')"
                      placeholder="zz/ll/aaaa"
                    >
                    </DatePicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="pt-3">
                <b-button variant="warning" size="sm" type="submit" class="float-right"><b-icon icon="search" /><span class="ml-2" v-translate>Search</span></b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="3">
            <img src="@/assets/images/mv/bg-transfer.jpeg" alt="mario-viajes" class="img-thumbnail">
          </b-col>
        </b-row>
      </b-col>
    </b-form>
  </div>
</template>

<script>
import DatePicker from 'b2b-common/components/datepicker'
export default {
  name: 'searchForm',
  components: { DatePicker },
  data () {
    return {
      transferFrom: null,
      to: null,
      transferType: null,
      transferLocation: [
        {
          value: 'a', text: 'Tenerife North Airport'
        },
        {
          value: 'b', text: 'Tenerife South'
        }
      ],
      transferTypes: [
        {
          value: 'a', text: 'Group A'
        },
        {
          value: 'b', text: 'Group B'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
